// src/plugins/loadingPlugin.js
import { ref } from "vue";
import axios from "axios";

export default {
  install(app) {
    const isLoading = ref(false);
    app.provide("isLoading", isLoading);

    app.config.globalProperties.$isLoading = isLoading;
    app.config.globalProperties.$showLoading = () => (isLoading.value = true);
    app.config.globalProperties.$hideLoading = () => (isLoading.value = false);

    let activeRequests = 0;

    // =====================================================
    //  🚀 Axios Interceptors
    // =====================================================
    axios.interceptors.request.use(
      (config) => {
        activeRequests++;
        isLoading.value = true;
        return config;
      },
      (error) => {
        activeRequests = Math.max(0, activeRequests - 1);
        if (activeRequests === 0) isLoading.value = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (response) => {
        activeRequests = Math.max(0, activeRequests - 1);
        if (activeRequests === 0) isLoading.value = false;
        return response;
      },
      (error) => {
        activeRequests = Math.max(0, activeRequests - 1);
        if (activeRequests === 0) isLoading.value = false;
        return Promise.reject(error);
      }
    );

    // =====================================================
    //  🚀 Global Fetch Interceptor
    // =====================================================
    const originalFetch = window.fetch;

    window.fetch = async (...args) => {
      try {
        activeRequests++;
        isLoading.value = true;

        const response = await originalFetch(...args);

        activeRequests = Math.max(0, activeRequests - 1);
        if (activeRequests === 0) isLoading.value = false;

        return response;
      } catch (error) {
        activeRequests = Math.max(0, activeRequests - 1);
        if (activeRequests === 0) isLoading.value = false;
        throw error;
      }
    };
  },
};
